module.exports = __webpack_public_path__ + "img/Gyorfi-Pal-home.8207a940.png";